import axiosInstance from '../axiosInterceptor/axiosInstance'

const getPlayerSeasonStats = async ({ orgId, playerId, seasonId, teamId }) => {
  const url = `v1/orgs/${orgId}/stats/players/${playerId}/season`
  const params = {}
  if (seasonId) params.seasonId = seasonId
  if (teamId) params.teamId = teamId
  return axiosInstance.get(url, { params: Object.keys(params).length ? params : undefined })
}

export default getPlayerSeasonStats
